import { CtaTypes } from '../../types/Cta';
import normalizeImage, { NormalizedImageData, RawImageData } from '../base/ImageBase';

export interface RawFeatureBannerWithListProps {
  id: number;
  type: string;
  sectionId: string;
  colorScheme: string;
  items: FeatureItem[];
  backgroundImage: RawImageData;
}

interface FeatureItem {
  id: number;
  title?: string;
  subtitle?: string;
  cta?: CtaTypes;
}

export interface NormalizedFeatureBannerWithListProps extends Omit<RawFeatureBannerWithListProps, 'backgroundImage' | 'id'> {
  backgroundImage: NormalizedImageData;
}


const FeatureBannerWithList = ({
  type,
  sectionId,
  colorScheme,
  items = [],
  backgroundImage,
  ...rest
}: RawFeatureBannerWithListProps): NormalizedFeatureBannerWithListProps => {
  const normalizedData: NormalizedFeatureBannerWithListProps = {
    type,
    sectionId,
    colorScheme,
    items,
    backgroundImage: normalizeImage(backgroundImage),
  }

  return normalizedData
}

export default FeatureBannerWithList
